module.exports = __webpack_public_path__ + "media/img/apple-touch-icon-iphone-defc1abbc15037ec869b432ad6e28a19.png";